import { Component, computed, inject, input, OnInit, output, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatListItem, MatNavList } from '@angular/material/list';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { RbacService } from 'src/app/services/rbac.service';

const ON_CUSTOMIDP = environment.ON_CUSTOMIDP;
const PROFILE = environment.ENV_ACTIVE_PROFILE;

@Component({
  selector: 'collapse-side-navigation',
  templateUrl: './collapse-side-navigation.component.html',
  styleUrls: ['./collapse-side-navigation.component.scss'],
  imports: [MatNavList, MatListItem, RouterLinkActive, RouterLink, TranslateModule],
})
export class CollapseSideNavigationComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  readonly listMenu = input<any[]>([]);
  protected rbacService = inject(RbacService);
  readonly expandSideNav = input<boolean>(true);
  readonly valueChange = output();
  readonly closeMenu = output();
  protected commonService = inject(CommonService);
  fullName: string = '';
  selectedRole: string = '';
  menuType: string = 'button'; // 'button' | 'accordination'
  private readonly userName = signal<string>('');
  profileName = computed(() => {
    const groupId = this.rbacService.getUser()?.groupId;
    return this.commonService.groupNameList().find((role) => role.value === groupId)?.label || '';
  });

  constructor() {}

  async ngOnInit() {
    if (PROFILE === ON_CUSTOMIDP) {
      this.updateUserName();

      window.addEventListener('localStorageChanged', (event: any) => {
        const key = event.key ?? event.detail?.key;
        if (key === 'clientName' || key === 'fullNameUser' || key === 'profilename' || key === 'userName') {
          this.updateUserName();
        }
      });
    }
  }

  private updateUserName() {
    const name = localStorage.getItem('clientName') || localStorage.getItem('fullNameUser') || localStorage.getItem('profilename') || localStorage.getItem('userName') || '';
    this.userName.set(name);
  }

  getUserName() {
    if (PROFILE === ON_CUSTOMIDP) {
      return this.userName();
    }
    return localStorage.getItem('fullNameUser') || localStorage.getItem('profilename');
  }

  onClick(item: any) {
    if (!item.isSelected) {
      localStorage.setItem('selectedSideNavigation', item.path);
      this.valueChange.emit(item);
      this.listMenu().forEach((_item) => {
        _item.isSelected = _item.path === item.path;
      });
    }
  }

  async initHome(isFirstTimeLogin: boolean) {
    const selectedPathKey = 'selectedSideNavigation';

    if (isFirstTimeLogin) {
      const match = this.listMenu().find((_item) => _item.inquire);
      if (match) {
        localStorage.setItem(selectedPathKey, match.path);
        this.onClick({
          path: match.path,
          isSelected: false,
        });
      }
      return;
    }

    const pathSegments = window.location.pathname.split('/').filter(Boolean); // ignore empty segments
    const lastSegment = pathSegments[pathSegments.length - 1];
    const secondLastSegment = pathSegments[pathSegments.length - 2];

    let isCreateProposal = lastSegment === 'product-selection';

    // Default to 'proposal' if URL is short or includes 'proposal'
    if (pathSegments.length <= 2 || pathSegments.includes('proposal')) {
      localStorage.setItem(selectedPathKey, 'proposal');
    }

    const selectedPath = localStorage.getItem(selectedPathKey);

    if (!isCreateProposal && secondLastSegment) {
      const match = this.listMenu().find((_item) => _item.path === secondLastSegment);
      if (match) {
        this.onClick({
          path: selectedPath,
          isSelected: false,
        });
      }
    }

    // Always update selection UI
    this.listMenu().forEach((_item) => {
      _item.isSelected = _item.path === selectedPath;
    });
  }
}
